import * as React from 'react';
import { Button } from '@teamsnap/teamsnap-ui';

import './WarningModal.scss';

type Props = {
  show: boolean;
  onClose: () => any;
  onSubmit: () => void;
  children?: React.ReactNode;
};

const WarningModal = ({ show, children, onClose, onSubmit }: Props) => (
    <>
      {show && (
        <div id="warning-modal">
          <div className="warning-modal__content">
            {children}
            <div className="buttons-wrapper">
              <Button type="button" mods="u-spaceRightSm" onClick={() => onClose()}>
                Cancel
              </Button>
              <Button
                mods="Button Button--primary"
                type="button"
                testId="continue-button"
                onClick={(e) => {
                  e.preventDefault();
                  onSubmit();
                }}
              >
                Yes, continue
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );

export default WarningModal;
